module.exports = __webpack_public_path__ + "static/media/dropdown-item-icon.81ed920b.svg";